module.exports = __webpack_public_path__ + "img/people-img-2.b69648c3.png";